import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    headerTitle: '我的收藏夹',
    backgroundColor: '#f5f5f5',
    cardColor: '#ffffff',
  });

  useEffect(() => {
    // 应用主题颜色到 CSS 变量
    document.documentElement.style.setProperty('--background-color', theme.backgroundColor);
    document.documentElement.style.setProperty('--card-color', theme.cardColor);
  }, [theme.backgroundColor, theme.cardColor]);

  const updateTheme = (newTheme) => {
    setTheme(prev => ({ ...prev, ...newTheme }));
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}; 